import React from "react";
import capitalizeFirstLetter from "./capitalizeFirstLetter";
import TableComponent from "./tableComponent";

function TabelSummary({ submittedData }) {

  const detailsTableColumns = [
    {
      label: "Device Type",
      field: "deviceType",
      headerClassName: "text-left pl-2 border-l border-t border-b border-black text-white",
      className: " text-left pl-2 border-l text-sm xl:text-base border-t border-b border-black",
      render:(item)=>(
        <>
          {capitalizeFirstLetter(item.deviceType)}
        </>
      )
    },
    {
      label: "Brand",
      field: "brandName",
      headerClassName: "text-left pl-2 border-t border-b border-black text-white",
      className: " text-left pl-2 text-sm xl:text-base border-t border-b border-black",
      render:(item)=>(
        <>
          {capitalizeFirstLetter(item.brandName)}
        </>
      )
    },
    {
      label: "Model",
      field: "modelNumber",
      headerClassName: "text-left pl-2 border-t border-b border-black text-white",
      className: " text-left pl-2 text-sm xl:text-base border-t border-b border-black",
      render:(item)=>(
        <>
          {item.modelNumber}
        </>
      )
    },
    {
      label: "No. of Devices",
      field: "noOfDevices",
      headerClassName: "text-left pl-2 border-t border-b border-black text-white",
      className: " text-left pl-4 text-sm xl:text-base border-t border-b border-black",
    },
    {
      label: "Service",
      field: "serviceName",
      headerClassName: "text-left pl-2 border-t border-b border-black text-white",
      className: " text-left pl-2 text-sm xl:text-base border-t border-b border-black",
      render:(item)=>(
        <>
          {capitalizeFirstLetter(item.service?.serviceName)}
        </>
      )
    },
    {
      label: "Problem",
      field: "problemDescription",
      headerClassName: "text-left pl-2 border-t border-b border-black text-white",
      className: " text-left pl-2 text-sm xl:text-base border-t border-b border-black",
      render:(item)=>(
        <>
          {capitalizeFirstLetter(item.problemDescription)}
        </>
      )
    },
    {
      label: "Estimated Cost ",
      field: "estimatedCost",
      headerClassName: "text-left pl-2 border-t border-b border-black text-white",
      className: " text-center pl-2 text-sm xl:text-base border-t border-b border-black",
      render:(item)=>(
        <>
          {parseFloat(item.estimatedCost)}
        </>
      )
    },
    {
      label: "Estimated Day",
      field: "estimatedDays",
      headerClassName: "text-left pl-2 border-t border-b border-black text-white",
      className: " text-center pl-2 text-sm xl:text-base border-t border-b border-black",
      // render: (row) => `${row.day} Day(s)`,
    },
    {
      label: "Total Cost ",
      field: "totalServiceCost",
      headerClassName: "text-left pl-2 border-r border-t border-b border-black text-white",
      className: " text-left pl-2 text-sm xl:text-base border-r border-t border-b border-black",
      render:(item)=>(
        <>
          {parseFloat(item.estimatedCost || 0) * parseInt(item.noOfDevices || 0)}
        </>
      )
    },
  ];
  return (
    <TableComponent
      columns={detailsTableColumns}
      data={submittedData || []}
      headerBg="bg-[#a63f40]"
    />
  );
}

export default TabelSummary;
